module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_library.js
// module id = 70
// module chunks = 2